export default "__VITE_ASSET__db9121eb__"